module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ca-Jb.249204d8.png";